module.exports = __webpack_public_path__ + "img/数据一体化.1ff9c79d.png";